import React, { useState, useEffect } from "react";
import {
  Container,
  Body,
  ButtonContainer,
  NavContainer,
  Button,
  Input,
  CollaboratorList,
  ButtonInvitation,
} from "./styles";

import ConfirmDelete from "../ConfirmDelete";
import { GrFormClose } from "react-icons/gr";
import { MdClose } from "react-icons/md";

import { Dropdown } from "semantic-ui-react";
import { Modal } from "semantic-ui-react";
import { toast } from "react-toastify";
import swal from "sweetalert";

import { producaov2 as api } from "../../../../../../services/apis";

const CollaboratorsManagementModal = ({
  closeModal,
  invitationTotal,
  setCollaborators,
  collaborators,
  licenseUse,
  collabMode = false,
  listCollaborators,
  confirmModal,
  setConfirmModal,
  companyId,
  companyName,
}) => {
  const [search, setSearch] = useState("");
  const [addCollabMode, setAddCollabMode] = useState(false);
  const [newCollabEmail, setNewCollabEmail] = useState("");
  const [filteredCollabs, setFilteredCollabs] = useState(collaborators);
  const [selectedCollaborator, setSelectedCollaborator] = useState("");

  const [collaboratorsInvited, setCollaboratorsInvited] = useState([]);
  const [currentUser, setCurrentUser] = useState({ email: "", level: 3 });
  const [isLoadingInvite, setIsLoadingInvite] = useState(false);

  useEffect(() => {
    if (!search) {
      setFilteredCollabs(collaborators);
      return;
    }

    const filtered = collaborators.filter((collaborator) =>
      collaborator.email.includes(search)
    );
    setFilteredCollabs(filtered);
  }, [collaborators, search]);

  // const addNewCollab = () => {
  //   if (!checkEmail(newCollabEmail)) return;

  //   const newCollabs = [...collaborators, { email: newCollabEmail }];
  //   setCollaborators(newCollabs);

  //   setNewCollabEmail("");
  // };

  const addNewCollab = () => {
    if (!checkEmail(currentUser.email)) return;

    setCollaboratorsInvited([...collaboratorsInvited, currentUser]);
    setCurrentUser({ email: "", level: 0 });

    toast.success("Convite adicionado à fila de envio!");
  };

  const checkEmail = (email) => {
    if (!email) return false;
    const emails = collaborators.map((collaborator) => collaborator.email);
    const emailsInvited = collaboratorsInvited.map(
      (collaborator) => collaborator.email
    );

    if (emails.includes(email)) {
      toast.error("Este email já faz parte desta empresa!");
      return false;
    }

    if (emailsInvited.includes(email)) {
      toast.error("Este email já está adicionado à lista de envio!");
      return false;
    }

    if (!email.includes("@") || !email.includes(".")) return false;

    return true;
  };

  const goBack = () => {
    setAddCollabMode(collabMode);
    setNewCollabEmail("");
  };

  const removeCollab = (index) => {
    const newCollabs = collaborators.filter((_, i) => i !== index);
    setCollaborators(newCollabs);
  };

  const handleSendInvite = async () => {
    if (!collaboratorsInvited.length) {
      toast.error("Por favor, adicione colaboradores.");
      return;
    }

    setIsLoadingInvite(true);

    await api
      .post(
        `/admin/incompany/collaborators/invite?company_id=${companyId}`,
        collaboratorsInvited.map((user) => ({
          email: user.email,
          level: user.level,
        }))
      )
      .then(async () => {
        swal("Sucesso", "Convites enviados com sucesso", "success");
        setCollaboratorsInvited([]);
        const logs = {
          local: `admin/lms/${companyId}`,
          texto: `Convidou o(s) colaborador(es) (${JSON.stringify(
            collaboratorsInvited
          )}) para a empresa ${companyName}[id_company:${companyId}]`,
        };
        await api.post("system_logs", {
          acao: JSON.stringify(logs),
        });
      })
      .catch(async (error) => {
        const logs = {
          local: `admin/lms/${companyId}`,
          texto: `Tentou convidar o(s) colaborador(es) (${JSON.stringify(
            collaboratorsInvited
          )}) para a empresa ${companyName}[id_company:${companyId}] - Erro: ${error}`,
        };
        await api.post("system_logs", {
          acao: JSON.stringify(logs),
        });
        swal("Erro", "Contacte TI para mais detalhes", "error");
      })
      .finally(() => {
        setIsLoadingInvite(false);
      });
  };

  const removeCollabInvited = (index) => {
    const newCollabs = collaboratorsInvited.filter((_, i) => i !== index);
    setCollaboratorsInvited(newCollabs);

    toast.success("Convite removido da fila de envio!");
  };

  const collabLevelOptions = [
    {
      key: 0,
      text: "Gestor",
      value: 1,
    },
    {
      key: 1,
      text: "Líder",
      value: 2,
    },
    {
      key: 2,
      text: "Colaborador",
      value: 3,
    },
  ];

  return (
    <Container>
      <div className="header">
        <h3>{listCollaborators ? "Colaboradores" : "Editar alunos"}</h3>
        <button onClick={closeModal}>
          <GrFormClose size={22} />
        </button>
      </div>

      <Body>
        {listCollaborators ? (
          <>
            <CollaboratorList>
              {filteredCollabs.length > 0 &&
                filteredCollabs.map((collaborator, index) => (
                  <div>
                    <p>{collaborator.email}</p>

                    <button
                      onClick={() => {
                        setSelectedCollaborator(index);
                        setConfirmModal(true);
                      }}
                    >
                      <MdClose size={18} />
                    </button>
                  </div>
                ))}
            </CollaboratorList>
            <Modal
              open={confirmModal}
              onClose={() => {
                setConfirmModal(false);
              }}
            >
              <ConfirmDelete
                closeModal={() => setConfirmModal(false)}
                deleteObject={() => removeCollab(selectedCollaborator)}
                copyModal={"colaborador"}
              />
            </Modal>
          </>
        ) : (
          <NavContainer>
            {addCollabMode ? (
              <>
                <input
                  type="text"
                  placeholder="Email do convidado"
                  className="email_input"
                  value={currentUser.email}
                  onChange={(e) =>
                    setCurrentUser({ ...currentUser, email: e.target.value })
                  }
                  disabled={invitationTotal <= licenseUse}
                  title={
                    invitationTotal <= licenseUse
                      ? "Limite de convites atingido - Entre em contato com o suporte para adquirir mais convites."
                      : ""
                  }
                  onKeyDown={(e) => e.key === "Enter" && addNewCollab()}
                />

                <div>
                  <Dropdown
                    placeholder={"Selecione uma opção"}
                    selection
                    options={collabLevelOptions}
                    onChange={(e, data) =>
                      setCurrentUser({ ...currentUser, level: data.value })
                    }
                    value={currentUser.level}
                    clearable
                  />
                </div>

                <div>
                  <ButtonInvitation
                    active={checkEmail(currentUser.email)}
                    onClick={addNewCollab}
                  >
                    Adicionar
                  </ButtonInvitation>

                  <button className="go_back" onClick={goBack}>
                    Voltar
                  </button>
                </div>
              </>
            ) : (
              <>
                <Button
                  active={addCollabMode}
                  onClick={() => setAddCollabMode(true)}
                >
                  Convidar colaborador
                </Button>

                <Input
                  type="text"
                  placeholder="Pesquisar aluno"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </>
            )}
          </NavContainer>
        )}

        <div>
          {collaboratorsInvited.length > 0 && (
            <CollaboratorList>
              {collaboratorsInvited.map((user, index) => (
                <div>
                  <p>{user.email}</p>
                  <p>{collabLevelOptions[user.level - 1].text}</p>
                  <button onClick={() => removeCollabInvited(index)}>
                    <MdClose size={18} />
                  </button>
                </div>
              ))}
            </CollaboratorList>
          )}
        </div>

        <ButtonContainer>
          <button
            onClick={() => {
              handleSendInvite();
              collaboratorsInvited.length > 0 && closeModal();
            }}
          >
            {collaboratorsInvited.length > 1
              ? "Enviar convites"
              : "Enviar convite"}
          </button>
        </ButtonContainer>
      </Body>
    </Container>
  );
};

export default CollaboratorsManagementModal;
